import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { WishlistProvider } from './context/WishlistContext';
import './App.css';

import HomePage from './pages/HomePage';
import ArchivePage from './pages/ArchivePage';
import CategoryPage from './pages/CategoryPage';
import TopicPage from './pages/TopicPage';
import BusinessDetailPage from './pages/BusinessDetailPage';
import AdminPage from './pages/AdminPage';
import NotFoundPage from './pages/NotFoundPage';
import ScopriPage from './pages/ScopriPage';
import PreferitePage from './pages/PreferitePage';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div
      key={location.pathname}
      className="animate-fade-in"
      style={{ animationDuration: '0.25s' }}
    >
      <Routes location={location}>
        <Route path="/"              element={<HomePage />} />
        <Route path="/attivita"      element={<ArchivePage />} />
        <Route path="/attivita/:slug" element={<BusinessDetailPage />} />
        <Route path="/categoria/:slug" element={<CategoryPage />} />
        <Route path="/argomento/:slug" element={<TopicPage />} />
        <Route path="/scopri"        element={<ScopriPage />} />
        <Route path="/preferiti"     element={<PreferitePage />} />
        <Route path="/admin"         element={<AdminPage />} />
        <Route path="/admin/*"       element={<AdminPage />} />
        <Route path="/404"           element={<NotFoundPage />} />
        <Route path="*"              element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <WishlistProvider>
      <BrowserRouter>
        <AnimatedRoutes />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </WishlistProvider>
  );
}

export default App;
